export default "__VITE_ASSET__Tl35wgfT__"